import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/manage-menucloud';

const list = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/itemGroups`, payload);
};

const create = (merchantId, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/itemGroups`, payload);
};

const find = (merchantId, id, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/itemGroups/${id}`, payload);
};

const update = (merchantId, id, payload) => {
	return Client.put(`${baseUrl}/${merchantId}/itemGroups/${id}`, payload);
};

const remove = (merchantId, id, payload) => {
	return Client.del(`${baseUrl}/${merchantId}/itemGroups/${id}`, payload);
};

export default {
	list,
	find,
	create,
	update,
	remove,
};
